import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { TIPOS_CHAVE } from '~/constants';
import format from '~/Utils/format';
import colors from '~/Utils/Styling/colors';
import ChaveId from '../ChaveId';
import ChaveDetails from '../ChaveDetails';
import ButtonPagamento from './ButtonPagamento';

function CardChave({ chave, onCardClick, onShowInfoRequested }) {
  const [showDetails, setShowDetails] = useState(false);

  function copyToClipboard(text) {
    const normalizedText = String(text || '').trim();
    if (!normalizedText) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(normalizedText)
        .then(() => toast.success('copiado'))
        .catch(() => {
          const ta = document.createElement('textarea');
          ta.value = normalizedText;
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            toast.success('copiado');
          } finally {
            document.body.removeChild(ta);
          }
        });
      return;
    }

    const ta = document.createElement('textarea');
    ta.value = normalizedText;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      toast.success('copiado');
    } finally {
      document.body.removeChild(ta);
    }
  }

  function toggleDetailsView(e) {
    e.stopPropagation();
    setShowDetails(!showDetails);
  }

  const bgClass =
    chave.nivel === 7
      ? colors.mutedLight
      : chave.selected
        ? '#cce5ff'
        : 'white';

  const cardStyle = {
    backgroundColor: bgClass,
    borderColor: chave.selected ? '#004085' : undefined,
    boxShadow: chave.selected
      ? '0 4px 12px rgba(0, 123, 255, 0.25)'
      : undefined,
    transform: chave.selected ? 'translateY(-1px)' : undefined,
    transition: 'all 0.2s ease-in-out',
  };

  function isSameDate(date1, date2) {
    if (!date1 || !date2) return false;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  const showCombinedVencimentoPagarEm =
    chave.data_vencimento &&
    chave.pagar_em &&
    isSameDate(chave.data_vencimento, chave.pagar_em);

  return (
    <Card
      style={cardStyle}
      className={`my-2 cursor-pointer arrow-bottom-left-${
        chave.tipo === TIPOS_CHAVE.Despesa ? 'danger' : 'primary'
      }`}
    >
      <Card.Body onClick={onCardClick} name="card-chave" className="px-3 py-1">
        {chave.nivel === 0 &&
          chave.codigo_usuario_digitacao !== chave.codigo_usuario_caixa && (
            <div className="rounded alert-danger text-center w-100 mb-3 p-1">
              <small className="d-block">
                <strong>
                  Esta chave não pode ser selecionada pois necessita de
                  correção. Utilize o GES para corrigir esta chave
                </strong>
              </small>
            </div>
          )}
        <div className="d-flex justify-content-between align-items-start mb-1">
          <div className="flex-grow-1 mr-2">
            <ChaveId chave={chave} />
          </div>
          <small className="text-muted text-nowrap" title="Data de criação">
            {format.date(chave.data)}
          </small>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-start">
              <small>
                {chave.digitalizacoes.length === 0 ? (
                  <strong className="text-danger">Sem digitalização</strong>
                ) : (
                  <strong className="text-success">
                    {chave.digitalizacoes.length}
                    {chave.digitalizacoes.length == 1
                      ? ' digitalização'
                      : ' digitalizações'}
                  </strong>
                )}
                {chave.digitalizacao_pendente && (
                  <span className="badge badge-primary d-inline-block ml-2">
                    Pendente
                  </span>
                )}
              </small>
              <small>Tipo {chave.tipo_documento}</small>
            </div>
          </div>
        </div>
        <div style={{ lineHeight: '1' }}>
          <div className="col-12 px-0">
            <div className="d-md-none">
              <div className="d-flex justify-content-between mb-3">
                <div
                  className="mb-1"
                  title={chave.usuario_digitacao.nome_usuario}
                >
                  <small className="text-muted d-block">Digitador</small>
                  <span className="d-block">
                    {chave.usuario_digitacao.nome}
                  </span>
                </div>
                <div className="text-right">
                  <div className="text-danger">
                    <small
                      className="d-block"
                      style={
                        showCombinedVencimentoPagarEm
                          ? { fontSize: '0.75em' }
                          : undefined
                      }
                    >
                      {showCombinedVencimentoPagarEm
                        ? 'Venc./Pagar em'
                        : 'Vencimento'}
                    </small>
                    <small
                      className="d-block"
                      style={
                        showCombinedVencimentoPagarEm
                          ? { fontSize: '0.85em' }
                          : undefined
                      }
                    >
                      {format.date(chave.data_vencimento)}
                    </small>
                  </div>
                  {!showCombinedVencimentoPagarEm && chave.pagar_em && (
                    <div className="text-info mt-1">
                      <small className="d-block">Pagar em</small>
                      <small className="d-block">
                        {format.date(chave.pagar_em)}
                      </small>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="mb-3">
                  <small className="text-muted d-block">
                    Modalidade: {chave.codigo_modalidade}
                  </small>
                  <span className="d-block">{chave.descricao_modalidade}</span>
                </div>
                {chave.valor_liquido === chave.valor_bruto ? (
                  <div>
                    <small className="text-muted d-block">Valor</small>
                    <span className="d-block">
                      {format.money(chave.valor_bruto)}
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="mr-3">
                      <small className="text-muted d-block">Líquido</small>
                      <small className="d-block">
                        {format.money(chave.valor_liquido)}
                      </small>
                    </div>
                    <div>
                      <small className="text-muted d-block">Bruto</small>
                      <small className="font-weight-bold d-block">
                        {format.money(chave.valor_bruto)}
                      </small>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="d-none d-md-block">
              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">Digitador</small>
                    </div>
                    <div className="col-10 pl-1">
                      <span title={chave.usuario_digitacao.nome_usuario}>
                        {chave.usuario_digitacao.nome}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">Modalidade</small>
                    </div>
                    <div className="col-10 pl-1">
                      <span>
                        {chave.codigo_modalidade} {chave.descricao_modalidade}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small
                        className="text-danger"
                        style={
                          showCombinedVencimentoPagarEm
                            ? { fontSize: '0.85em' }
                            : undefined
                        }
                      >
                        {showCombinedVencimentoPagarEm
                          ? 'Venc./Pagar em'
                          : 'Vencimento'}
                      </small>
                    </div>
                    <div className="col-10 pl-1">
                      <small
                        className="text-danger"
                        style={
                          showCombinedVencimentoPagarEm
                            ? { fontSize: '0.85em' }
                            : undefined
                        }
                      >
                        {format.date(chave.data_vencimento)}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {!showCombinedVencimentoPagarEm && chave.pagar_em && (
                <div className="row mb-2">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-2 text-right pr-1">
                        <small className="text-info">Pagar em</small>
                      </div>
                      <div className="col-10 pl-1">
                        <small className="text-info">
                          {format.date(chave.pagar_em)}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">
                        {chave.valor_liquido === chave.valor_bruto
                          ? 'Valor'
                          : 'Líquido/Bruto:'}
                      </small>
                    </div>
                    <div className="col-10 pl-1">
                      {chave.valor_liquido === chave.valor_bruto ? (
                        <span>{format.money(chave.valor_bruto)}</span>
                      ) : (
                        <span>
                          <small>{format.money(chave.valor_liquido)} / </small>
                          <small className="font-weight-bold">
                            {format.money(chave.valor_bruto)}
                          </small>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ lineHeight: '1' }}>
          <div className="col-12 px-0">
            <div className="d-md-none">
              <div className="mb-3">
                <small className="text-muted d-block">
                  Departamento: {chave.codigo_departamento}
                </small>
                <span className="d-block">{chave.departamento.descricao}</span>
              </div>
              <div className="mb-3">
                <small className="text-muted d-block">
                  Fornecedor: {chave.codigo_conta_fornecedor}
                </small>
                <span className="d-block">
                  {chave.fornecedor.apelido_conta}
                </span>
              </div>
              <div className="mb-3">
                <small className="text-muted d-block">
                  Conta: {chave.codigo_conta_portador}
                </small>
                <span className="d-block">
                  {chave.conta_portador.apelido_conta}
                </span>
              </div>
            </div>
            <div className="d-none d-md-block">
              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">Departamento</small>
                    </div>
                    <div className="col-10 pl-1">
                      <span>
                        {chave.codigo_departamento}{' '}
                        {chave.departamento.descricao}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">Fornecedor</small>
                    </div>
                    <div className="col-10 pl-1">
                      <span>
                        {chave.codigo_conta_fornecedor}{' '}
                        {chave.fornecedor.apelido_conta}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    <div className="col-2 text-right pr-1">
                      <small className="text-muted">Conta</small>
                    </div>
                    <div className="col-10 pl-1">
                      <span>
                        {chave.codigo_conta_portador}{' '}
                        {chave.conta_portador.apelido_conta}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-12">
                  <div className="row">
                    {chave.barras && chave.tipocod === 'D' && (
                      <>
                        <div className="col-2 text-right pr-1">
                          <small className="text-muted">Linha digitável:</small>
                        </div>
                        <div className="col-10 pl-1">
                          <small className="linha-digitavel">
                            {chave.barras}
                          </small>
                        </div>
                      </>
                    )}
                    {chave.barras && chave.tipocod === 'B' && (
                      <>
                        <div className="col-2 text-right pr-1">
                          <small className="text-muted">Código leitor:</small>
                        </div>
                        <div className="col-10 pl-1">
                          <small className="linha-digitavel">
                            {chave.barras}
                          </small>
                        </div>
                      </>
                    )}
                    {chave.tipocod === 'P' && chave.pix_qr_code && (
                      <>
                        <div className="col-2 text-right pr-1">
                          <small className="text-muted">Código PIX:</small>
                        </div>
                        <div className="col-10 pl-1">
                          <small
                            className="linha-digitavel"
                            style={{
                              display: 'block',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              maxWidth: '100%',
                              cursor: 'pointer',
                            }}
                            title="Clique para copiar"
                            onClick={e => {
                              e.stopPropagation();
                              copyToClipboard(chave.pix_qr_code);
                            }}
                          >
                            {String(chave.pix_qr_code || '').trim()}
                          </small>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="col-12 px-0 mb-1">
            <ButtonPagamento
              chave={chave}
              renderButtons={paymentButton => (
                <div className="d-flex align-items-center">
                  {paymentButton}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="px-2 ml-auto"
                    style={{ minWidth: '130px' }}
                    onClick={toggleDetailsView}
                  >
                    {showDetails ? 'Ocultar' : 'Ver'} detalhes
                  </Button>
                </div>
              )}
            />
          </div>
        </div>

        {showDetails && (
          <ChaveDetails
            chave={chave}
            onShowInfoRequested={onShowInfoRequested}
          />
        )}
      </Card.Body>
    </Card>
  );
}

export default React.memo(CardChave);
